import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IPartner, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    name: yup.string().required("Partner Name Type is required"),
    email: yup.string().email().nullable(),
    contact: yup.string().nullable(),
    industryTypeId: yup.number().required("Industry Type is required").min(1, "Industry Type is required")
});

interface Iprops {
    singleData: IPartner,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [industryTypes, setIndustryTypes] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<IPartner>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    useEffect(() => {
        loadIndustryTypes();
    }, []);

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadIndustryTypes = async () => {
        const response = await Fetch("industrytype/dropdown", "GET", null, null, null);
        if (response) {
            setIndustryTypes(await response.json());
        }
    }


    const saveToDB = async (body: IPartner) => {
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`partner${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Partner" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVInput required label="Name" control={control} name="name" error={errors.name?.message} />
                <JVInput label="Email" control={control} name="email" error={errors.email?.message} />
                <JVInput label="Contact" control={control} name="contact" error={errors.contact?.message} />
                <JVDropdown required label="Industry Type" control={control} options={industryTypes} optionLabel="name" optionValue="id" name="industryTypeId" placeholder="Select Industry Type" error={errors.industryTypeId?.message} />
                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}